module.exports = __webpack_public_path__ + "img/jacket1.99ae3998.png";